module.exports = __webpack_public_path__ + "static/half-circle-inverted.54f56c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/half-circle-inverted.png
// module id = 348
// module chunks = 35783957827783